// extracted by mini-css-extract-plugin
module.exports = {"Container":"PoppingBadge_Container__2puC8","ContainerIn":"PoppingBadge_ContainerIn__3a7-n"};